<template>
  <div class="m-12">
    <div v-if="params.node.failedLoad" class="flex items-center">
      <FontAwesomeIcon
        :icon="['fak', 'x']"
        class="text-danger-accent w-16 h-16"
      />
      <span>Failed to load</span>
    </div>
    <FontAwesomeIcon
      v-else
      :icon="['fak', 'loading']"
      spin
      class="text-neutral-accent w-16 h-16"
    />
  </div>
</template>

<script lang="ts" setup>
import { ICellRendererParams } from '@ag-grid-community/core';

const { params } = defineProps<{
  params: ICellRendererParams;
}>();
</script>
